import React, { useState, useContext, useEffect } from 'react';
import { PageContext } from '@/context/PageContext';
import { Icon } from 'components/Atoms/Icon/Icon';
import { useTranslation } from 'react-i18next';
import { format, differenceInMinutes } from 'date-fns';
import classNames from 'classnames';
import styles from './SurveyClosedBanner.module.scss';

export function SurveyClosedBanner() {
  const { survey, userInteraction, questionnaire } = useContext(PageContext);
  const [clientRender, setClientRender] = useState(false);
  const { t } = useTranslation();
  const endTimeString = survey?.end_time ?? questionnaire?.end_time;
  useEffect(() => {
    if (endTimeString) {
      const endDate = new Date(endTimeString);
      const currentDate = new Date();
      const minutesDifference = differenceInMinutes(endDate, currentDate);
      if (minutesDifference <= 60 && minutesDifference >= 0) {
        setClientRender(true);
      } else {
        setClientRender(false);
      }
    }
  }, [endTimeString, userInteraction]);

  let endTimeLocalized = '';
  if (endTimeString) {
    const endTime = new Date(endTimeString);
    endTimeLocalized = format(endTime, 'MMMM d yyyy hh:mm a');
  }

  if (!clientRender) {
    return null; // ensure this is only rendered on client as locale string is client side only.
  }

  return (
    <div
      id="SurveyClosedBanner"
      data-testid="SurveyClosedBanner"
      className={classNames(styles.headerSurveyClosedBanner, 'optionalBanner')}
    >
      <div className={styles.innerContainer}>
        <Icon classname={styles.icon} name="info" /> {t('survey.closingSoonBanner', { date: endTimeLocalized })}
      </div>
    </div>
  );
}
